export function calculaDiferencaDias(value) {
  const hoje = new Date();
  const dataVencimento = new Date(value);
  dataVencimento.setHours(0, 0, 0, 0);
  return Math.ceil((dataVencimento - hoje) / (1000 * 60 * 60 * 24));
}

export function renderTextoAviso(diferencaDias) {
  let texto = `${Math.abs(diferencaDias)} dias atrasado`;
  if (diferencaDias === 0) {
    texto = "Hoje";
  } else if (diferencaDias > 0) {
    texto = `em ${diferencaDias} dias`;
  }
  return texto;
}

export function renderColorAviso(diferencaDias) {
  let color = "#e62b34";
  if (diferencaDias >= 0 && diferencaDias <= 30) {
    color = "#fe9a00";
  } else if (diferencaDias > 30) {
    color = "#51686f";
  }
  return color;
}

export function getStatusInfo(status, dataVencimento) {
  const diferencaDias = calculaDiferencaDias(dataVencimento);
  let label = "NOTIFICADO",
    backgroundColor = "#008b5b",
    color = "#fcfcfc";

  if (status === "PENDENTE") {
    if (diferencaDias >= 0 && diferencaDias <= 30) {
      label = "PRÓXIMO";
      backgroundColor = "#fe9a00";
      color = "#fcfcfc";
    } else if (diferencaDias < 0) {
      label = "ATRASADO";
      backgroundColor = "#e62b34";
      color = "#fcfcfc";
    } else {
      label = "REALIZADO";
      (backgroundColor = "#d3e1e2"), (color = "#001718");
    }
  } else if (status === "AGENDADO") {
    label = "AGENDADO";
    backgroundColor = "#1769aa";
    color = "#fcfcfc";
  }

  return { label, backgroundColor, color };
}

export function getAcoesButtonInfo(status) {
  if (status === "NOTIFICADO") {
    return {
      label: "Agendar",
      icon: "ph-calendar-dots",
      backgroundColor: "#1769aa",
    };
  }

  return {
    label: "Notificar",
    icon: "ph-chat-circle",
    backgroundColor: "#008b5b",
  };
}